export default __webpack_public_path__ + "static/media/colors_expiring_dox.95277fcc.png";